import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import supabase from '../../../supabase/supabase';
import SafeIcon from '../../../common/SafeIcon';

const ParticipantView = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [checkedIn, setCheckedIn] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkStatus = async () => {
      const today = new Date().toISOString().split('T')[0];
      const { data } = await supabase
        .from('attendance_1741860000000')
        .select('*')
        .eq('user_id', user.id)
        .gte('check_in_time', `${today}T00:00:00`)
        .limit(1);
      if (data?.length > 0) setCheckedIn(true);
    };
    if (user) checkStatus();
  }, [user]);

  const handleCheckIn = async () => {
    setLoading(true);
    try {
      const { error } = await supabase
        .from('attendance_1741860000000')
        .insert([{
          user_id: user.id,
          session_name: "Strategic Leadership Workshop",
          check_in_time: new Date().toISOString()
        }]);
      if (error) throw error;
      setCheckedIn(true);
      alert("✅ Check-in successful!");
    } catch (err) {
      alert("Check-in failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-2 h-full bg-gold-500"></div>
        <div className="flex-1">
          <h2 className="text-xl font-bold text-navy-900 mb-1">Today's Session</h2>
          <p className="text-slate-600 text-sm">Mental Health & Complex Needs Excellence • Day 1</p>
        </div>
        {!checkedIn ? (
          <button onClick={handleCheckIn} disabled={loading} className="bg-navy-900 text-white px-8 py-4 rounded-xl font-bold flex items-center gap-2 hover:bg-navy-800 disabled:opacity-50 shadow-lg">
            <SafeIcon name="CheckCircle" className="text-gold-500" /> {loading ? 'Processing...' : 'Check-In Now'}
          </button>
        ) : (
          <div className="bg-green-50 text-green-700 px-6 py-4 rounded-xl font-bold flex items-center gap-2 border border-green-200">
            <SafeIcon name="Check" /> Attendance Logged
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div onClick={() => navigate('/portal/participant/certificates')} className="bg-white p-8 rounded-2xl border border-slate-200 hover:border-gold-500 cursor-pointer transition-all group shadow-sm">
          <div className="w-12 h-12 bg-navy-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-navy-900 transition-colors">
            <SafeIcon name="Award" className="text-navy-900 group-hover:text-gold-500" />
          </div>
          <h3 className="text-lg font-bold text-navy-900">My Certificates</h3>
          <p className="text-slate-500 text-sm mb-4">Access and download your earned credentials.</p>
          <span className="text-navy-900 font-bold text-sm flex items-center gap-2">View Records <SafeIcon name="ArrowRight" className="w-4 h-4" /></span>
        </div>

        <div onClick={() => navigate('/portal/participant/mentoring')} className="bg-white p-8 rounded-2xl border border-slate-200 hover:border-gold-500 cursor-pointer transition-all group shadow-sm">
          <div className="w-12 h-12 bg-navy-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-navy-900 transition-colors">
            <SafeIcon name="Target" className="text-navy-900 group-hover:text-gold-500" />
          </div>
          <h3 className="text-lg font-bold text-navy-900">Mentoring Roadmap</h3>
          <p className="text-slate-500 text-sm mb-4">Track your 10-week leadership journey.</p>
          <span className="text-navy-900 font-bold text-sm flex items-center gap-2">Track Progress <SafeIcon name="ArrowRight" className="w-4 h-4" /></span>
        </div>
      </div>
    </div>
  );
};

export default ParticipantView;